import comp from "./ToolResponse";
import withLoader from "UIComponents/GqlWithLoader";
export default withLoader(comp);
